/** Wire types, mirroring schema/setup-protocol.schema.json. */
const B64URL = /^[A-Za-z0-9_-]+$/;
export function isEnvelope(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const v = value;
    if (v['v'] !== 1 || (v['from'] !== 'web' && v['from'] !== 'phone'))
        return false;
    if (v['t'] === 'hello')
        return typeof v['pub'] === 'string' && v['pub'].length === 43 && B64URL.test(v['pub']);
    if (v['t'] === 'msg') {
        return typeof v['n'] === 'string' && v['n'].length === 16 && B64URL.test(v['n'])
            && typeof v['c'] === 'string' && B64URL.test(v['c']);
    }
    return false;
}
export function isControl(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const v = value;
    if (v['t'] === 'wake')
        return Object.keys(v).length === 1;
    if (v['t'] !== 'push')
        return false;
    return typeof v['token'] === 'string' && /^[0-9a-f]{64,200}$/i.test(v['token'])
        && (v['env'] === 'sandbox' || v['env'] === 'production');
}
export function isJoin(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const v = value;
    if (v['t'] !== 'join' || (v['role'] !== 'web' && v['role'] !== 'phone'))
        return false;
    const hasSession = typeof v['session'] === 'string' && v['session'].length === 22 && B64URL.test(v['session']);
    const hasCode = typeof v['code'] === 'string' && /^[0-9]{6}$/.test(v['code']);
    return hasSession !== hasCode;
}
//# sourceMappingURL=envelope.js.map